import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class InStock extends BaseCom {
    
    async componentDidMount() {
        await this.load();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/inventory/instock');
            if(j.list)
                this.setState({list: j.list});
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>In Stock</h1>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Manufacturer</th>
                            <th>Product</th>
                            <th>Size</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list?.map((i,idx) => <tr key={idx}>
                            <td>{i.manufacturerName}</td>
                            <td>{i.productName}</td>
                            <td>{i.productSize}</td>
                            <td>{i.counter}</td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withParamsAndNavigate(InStock);